import { FONT_WEIGHT_BOLD } from 'constants/styleConstants'
import { css } from 'emotion'

export const textBoldStyles = css`
  font-weight: ${FONT_WEIGHT_BOLD};
`
